export const TARGET_RATIONALE_PAGE_TABS = {
  RAC_APPROVED_TOPICS_TAB: "RAC Approved Topics",
  TARGET_RATIONALE_TAB: "Target Rationale",
};
export const TARGET_RATIONALE_DETAIL_POPUP_MODE = {
  ADD: "ADD",
  EDIT: "EDIT",
};

export const convertTextToMixedHTMLList = (text?: string | undefined | null): string => {
  if (!text || typeof text !== "string") {
    return ""; // Return safe default HTML string
  }

  const lines = text
    .split(/\n+/)
    .map((line) => line.trim())
    .filter((line) => line);

  let html = "";
  let currentListType: "ol" | "ul" | null = null;

  const isNumbered = (line: string) => /^\d+[\.\)]\s/.test(line);
  const isBulleted = (line: string) => /^[-*•]\s+/.test(line);

  lines.forEach((line, idx) => {
    if (isNumbered(line)) {
      if (currentListType !== "ol") {
        if (currentListType) html += `</${currentListType}>`;
        html += "<ol>";
        currentListType = "ol";
      }
      html += `<li>${line.replace(/^\d+[\.\)]\s+/, "")}</li>`;
    } else if (isBulleted(line)) {
      if (currentListType !== "ul") {
        if (currentListType) html += `</${currentListType}>`;
        html += "<ul>";
        currentListType = "ul";
      }
      html += `<li>${line.replace(/^[-*•]\s+/, "")}</li>`;
    } else {
      // If not a list item, close list if open and add as paragraph
      if (currentListType) {
        html += `</${currentListType}>`;
        currentListType = null;
      }
      html += `<p>${line}</p>`;
    }
  });
  if (currentListType) {
    html += `</${currentListType}>`;
  }
  return html;
};

export const convertMixedHTMLToTextList = (html?: string | null): string => {
  if (!html || typeof html !== "string") {
    return "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const output: string[] = [];

  doc.body.childNodes.forEach((node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    const element = node as HTMLElement;

    if (element.tagName === "OL") {
      const items = element.querySelectorAll("li");
      items.forEach((li, index) => {
        output.push(`${index + 1}. ${li.textContent?.trim()}`);
      });
    } else if (element.tagName === "UL") {
      const items = element.querySelectorAll("li");
      items.forEach((li) => {
        output.push(`• ${li.textContent?.trim()}`);
      });
    } else if (element.tagName === "P") {
      const text = element.textContent?.trim();
      if (text) {
        output.push(text);
      }
    }
  });

  return output.join("\n");
};

